<template>
  <div ref="queryForm">
    <el-form
      ref="forms"
      :class="More ? 'glo_form hasMoreParam jy-common-el-form' : 'glo_form jy-common-el-form'"
      label-position="left"
    >
      <el-row :gutter="26">
        <el-col :span="9" class="fieldTime" v-if="hasTimeType" >
<!--          <el-form-item-->
<!--              class="queryItemsTimes"-->
<!--              v-if="hasTimeType"-->
<!--          >-->
            <div class="timeBox" v-if="hasTimeType" style="display: flex">
              <el-select
                  v-model="F_config[timeTypeIndex].conditonVal"
                  clearable
                  remote
                  filterable
                  placeholder="选择时间类型"
                  style="width: 120px; min-width: 100px"
                  :remote-method="(e) => { remoteMethod(e, item, index); }"
                  @visible-change="focusMethod($event, item, index)"
                  @clear="remoteMethod('', item, index)"
              >
                <el-option
                    v-for="(option, num) in F_config[timeTypeIndex].selectOptions"
                    :label="option[F_config[timeTypeIndex].dropdownShowField]"
                    :value="option[F_config[timeTypeIndex].dropdownSubmitField]"
                    :key="num"
                />
              </el-select>
              <div class="timeRqHb" style="margin-left: 5px; min-width: 470px; display: flex; line-height: 28px;">
                <el-date-picker
                    class="jy-form-time"
                    value-format="yyyy-MM-dd"
                    v-model="F_config[startTimeIndex].conditonVal"
                    type="date"
                    placeholder="选择开始日期"
                ></el-date-picker>
                <span>至</span>
                <el-date-picker
                    class="jy-form-time"
                    value-format="yyyy-MM-dd"
                    v-model="F_config[endTimeIndex].conditonVal"
                    type="date"
                    placeholder="选择结束日期"
                ></el-date-picker>
              </div>

            </div>
<!--          </el-form-item>-->
        </el-col>
        <el-col :span="6"  v-for="(item, index) in F_config" :key="index" v-show="item.isShow" class="fieldCla" :class="{'time-input': item.textBoxType === 'datetime'}">
<!--          <el-col :span="6" :key="index" v-show="item.isShow">-->
            <el-form-item
              class="jy-form-input"
              v-if="item.textBoxType === 'input'"
              :label="item.conditonKeyShow + ':'"
            >
              <!-- v-model="F_Data[item.conditonKey]" -->
                <el-input
                  v-model="item.conditonVal"
                  placeholder="请输入"
                  clearable
                ></el-input>
            </el-form-item>

            <el-form-item
              class="jy-form-input"
              v-if="item.textBoxType === 'input_more'"
              :label="item.conditonKeyShow + ':'"
            >
              <!-- v-model="F_Data[item.conditonKey]" -->
              <el-input
                v-model="item.conditonVal"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              class="jy-form-time months"
              v-if="item.textBoxType === 'date_month'"
              :label="item.conditonKeyShow + ':'"
            >
              <!-- v-model="F_Data[item.conditonKey]" -->
              <el-date-picker
                prefix-icon="''"
                value-format="yyyy-MM"
                v-model="item.conditonVal"
                type="month"
                placeholder="选择月"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              class="jy-form-select"
              v-if="item.textBoxType === 'select'"
              :label="item.conditonKeyShow + ':'"
            >
              <!-- v-model="F_Data[item.conditonKey]" -->

              <el-select
                v-model="item.conditonVal"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod(e, item, index);
                  }
                "
                @visible-change="focusMethod($event, item, index)"
                @clear="remoteMethod('', item, index)"
              >
                <!-- @focus="
                  (e) => {
                    focusMethod(item, index);
                  }
                " -->
                <el-option
                  v-for="(option, num) in item.selectOptions"
                  :label="option[item.dropdownShowField]"
                  :value="option[item.dropdownSubmitField]"
                  :key="num"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              class="jy-form-select"
              v-if="item.textBoxType === 'select_object'"
              :label="item.conditonKeyShow + ':'"
            >
              <el-select
                v-model="item.conditonVal"
                :disabled="
                  item.conditonKey == 'objectName' &&
                  !F_config[index - 1].conditonVal
                "
                clearable
                remote
                filterable
                @visible-change="getList($event, item, index)"
                @change="
                  changeObjVal($event, item, index, item.dropdownSubmitField)
                "
                :remote-method="
                  (e) => {
                    remoteMethodOBJ(e, item, index);
                  }
                "
              >
                <el-option
                  v-for="(option, num) in item.selectOptions"
                  :label="option[item.dropdownShowField]"
                  :value="option[item.dropdownSubmitField]"
                  :key="num"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              class="jy-form-time"
              v-if="item.textBoxType === 'datetime' && !hasTimeType"
            >
              <multitime
                :timeType="item.timeType"
                :timeTypes="item.timeTypes"
                :startTime="item.startTime_a"
                :endTime="item.endTime_a"
                @timestatus="
                  (type, s, e) => {
                    timestatus(type, s, e, index);
                  }
                "
                @queryBtn_ok="
                  (s, e) => {
                    queryBtn_time(s, e, index);
                  }
                "
              ></multitime>
            </el-form-item>
            <el-form-item
              class="jy-form-time"
              v-if="item.textBoxType === 'date'"
            >
              <multitime
                :timeType="item.timeType"
                :timeTypes="item.timeTypes"
                :startTime="item.startTime_a"
                :endTime="item.endTime_a"
                @timestatus="
                  (type, s, e) => {
                    timestatus(type, s, e, index);
                  }
                "
                @queryBtn_ok="
                  (s, e) => {
                    queryBtn_time(s, e, index);
                  }
                "
              ></multitime>
            </el-form-item>
<!--          </el-col>-->
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import multitime from "@/components/multiTimeDT.vue";
export default {
  components: { multitime },
  props: {
    formConfig: {
      type: Array,
    },
    formData: {
      type: Object,
    },
    More: {
      type: Boolean,
    },
  },
  emits: ["changeCallback", "EnterClick"],
  data() {
    return {
      F_config: this.formConfig,
      F_Data: this.formData,
      hasTimeType: false,
      timeTypeIndex: -1, // 新增
      startTimeIndex: -1, // 新增
      endTimeIndex: -1,   // 新增
    };
  },
  watch: {
    formConfig: {
      handler(newValue, oldValue) {
        this.F_config = newValue;
        // console.log("F_config", this.F_config);
        let startTimeIndex = -1;
        let endTimeIndex = -1;
        let timeTypeIndex = -1;

        this.F_config.forEach((item, index) => {
          if (item.conditonKey === 'startTime') startTimeIndex = index;
          if (item.conditonKey === 'endTime') endTimeIndex = index;
          if (item.conditonKey === 'timeType') timeTypeIndex = index;
        });

        this.startTimeIndex = startTimeIndex;
        this.endTimeIndex = endTimeIndex;
        this.timeTypeIndex = timeTypeIndex;

        // 判断是否有 timeType 字段
        this.hasTimeType = this.F_config.some(item => item.conditonKey === 'timeType');

      },
      deep: true, // 默认值是 false，代表是否深度监听
    },
  },
  methods: {
    getFormData() {
      // 返回当前表单数据
      return this.formData;
    },
    setFormData(data) {
      // 设置表单数据
      this.formData = { ...this.formData, ...data };
    },
    // 选择结算对象
    changeObjVal(val, item, index, key) {
      if (item.conditonKey == "objectStatusConfDictId") {
        // this.F_config[index + 1].conditonVal = "";
        this.$set(this.F_config[index + 1], 'conditonVal', '');

        let list = item.selectOptions || [];

        list.forEach((element) => {
          if (element[key] == val) {
            // this.F_config[index].key = element.key;
            this.$set(this.F_config[index], 'key', element.key);

          }
        });
      }else if (item.conditonKey == "itemCategoryId") {
        // this.F_config[index + 1].conditonVal = "";
        this.$set(this.F_config[index + 1], 'conditonVal', '');

        let list = item.selectOptions || [];
        list.forEach((element) => {
          if (element[key] == val) {
            this.$set(this.F_config[index], 'key', element.itemCategoryId);
          }
        });
      }
    },
    // 获取结算对象/类型下拉列表
    async getList(e, item, index) {
      // this.F_config[index].selectOptions = [];
      // 使用 $set 确保响应式更新
      this.$set(this.F_config[index], 'selectOptions', []);

      if (e) {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: "",
          },
        ];
        if (item.conditonKey == "objectName") {
          // item.conditonKey == 'objectName' && !F_config[index-1].conditonVal
          arrs.push({
            conditonKey: "key",
            // conditonVal: this.F_config[index - 1].key,
            conditonVal: this.F_config[index - 1].key,

          });
        }else if (item.conditonKey == "itemServiceId") {
          // item.conditonKey == 'objectName' && !F_config[index-1].conditonVal
          arrs.push({
            conditonKey: "itemCategoryId",
            // conditonVal: this.F_config[index - 1].key,
            conditonVal: this.F_config[index - 1].key,

          });
        }
        await this.$API
          .runPageReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 20,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            // this.F_config[index].selectOptions = datas;
            let fdata = JSON.parse(JSON.stringify(this.F_config));
            fdata[index].selectOptions = datas;
            // this.F_config = fdata;
            // 使用 $set 确保响应式更新
            this.$set(this.F_config[index], 'selectOptions', datas);

          });
      }
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e, index) {
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e, index) {
      this.F_config[index].timeType = type || "";
      // this.F_config[index].startTime_a = `${s} 00:00:00` || "";
      // this.F_config[index].endTime_a = `${e} 23:59:59` || "";
      this.F_config[index].startTime_a = s || "";
      this.F_config[index].endTime_a = e || "";
    },
    async focusMethod(type, item, index) {
      if (!type) {
        return false;
      }
      // if (this.F_config[index].selectOptions.length == 0) {
      if (item.conditonKey == "fieldName") {
        // 不分页查询

        this.$API
          .runPageReportDetails({
            number: item.dropdownApiNumber,
            conditionReqs: [
              {
                conditonKey: item.dropdownShowField,
                conditonVal: "",
              },
            ],
          })
          .then((res) => {
            let datas = res.data.result.datas || [];
            // this.F_config[index].selectOptions = datas;
            this.$set(this.F_config[index], 'selectOptions', datas);

          });
      } else {
        // 分页查询
        await this.$API
          .runPageReport({
            conditionReqs: [
              {
                conditonKey: item.dropdownShowField,
                conditonVal: "",
              },
            ],
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 100,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            // this.F_config[index].selectOptions = datas;
            this.$set(this.F_config[index], 'selectOptions', datas);

          });

      }
      // }
    },
    // 远程搜索
    async remoteMethod(e, item, index) {
      await this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: item.dropdownShowField,
              conditonVal: e,
            },
          ],
          number: item.dropdownApiNumber,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let datas = res.data.result.datas.data || [];
          // this.F_config[index].selectOptions = datas;
          this.$set(this.F_config[index], 'selectOptions', datas);

        });
      this.$emit("changeCallback", e, name);

    },
    // 远程搜索(结算对象/类型)
    async remoteMethodOBJ(e, item, index) {
      if (item.conditonKey == "objectName") {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: e,
          },
        ];
        arrs.push({
          conditonKey: "key",
          conditonVal: this.F_config[index - 1].key,
        });
        // if (item.conditonKey == "objectName") {
        //   arrs.push({
        //     conditonKey: "key",
        //     conditonVal: this.F_config[index - 1].key,
        //   });
        // }
        await this.$API
          .runPageReport({
            conditionReqs: arrs,
            number: item.dropdownApiNumber,
            pageStart: 1,
            pageTotal: 20,
          })
          .then((res) => {
            let datas = res.data.result.datas.data || [];
            this.F_config[index].selectOptions = datas;
          });
      }else if (item.conditonKey == "itemServiceId") {
        let arrs = [
          {
            conditonKey: item.dropdownShowField,
            conditonVal: e,
          },
        ];
        arrs.push({
          conditonKey: "itemCategoryId",
          conditonVal: this.F_config[index - 1].key,
        });
        await this.$API
            .runPageReport({
              conditionReqs: arrs,
              number: item.dropdownApiNumber,
              pageStart: 1,
              pageTotal: 20,
            })
            .then((res) => {
              let datas = res.data.result.datas.data || [];
              this.F_config[index].selectOptions = datas;
            });
      }
    },
    // 滚动条加载更多
    loadmore(e) {
      this.$emit("changeCallback", "", e);
    },
    enterClick() {
      this.$emit("EnterClick");
    },
  },
};
</script>
<style lang="scss" scoped>

//.months {
//  .el-date-editor.el-input,
//  .el-date-editor.el-input__inner {
//    // width: 210px !important;
//    min-width: auto;
//    width: auto;
//  }
//
//  // .el-input__prefix {
//  //   right: 5px !important;
//  // }
//}
::v-deep .jy-form-input ,
::v-deep .jy-form-time ,
::v-deep .jy-form-select  {
  display: flex !important;
  width: 100% !important;
  line-height: 28px !important;
  height: 28px !important;
}
::v-deep .jy-form-input .el-form-item__label ,
::v-deep .jy-form-time .el-form-item__label,
::v-deep .jy-form-select .el-form-item__label {
  min-width: 100px !important;
  line-height: 18px !important;
  height: 28px !important;
  text-align: right !important; // 靠右对齐
}
::v-deep .el-input__inner {
  line-height: 28px !important;
  height: 28px !important;
  border: none ;
}
::v-deep .el-form-item__content {
  line-height: 28px !important;
  height: 28px !important;
  border: none ;
  //溢出隐藏
  overflow: hidden;
}

.jy-common-el-form .el-row .fieldTime{
  border: 1px solid #cccccc;
  line-height: 28px !important;
  height: 28px !important;
  //溢出隐藏
  overflow: hidden;
  margin-right: 5px;
  border-radius: 5px;
}
.jy-common-el-form .el-row .fieldCla{
  padding: 0px;
  line-height: 28px !important;
  height: 28px !important;
  border: 1px solid #cccccc;
  margin-right: 6px;
  margin-bottom: 10px;
  border-radius: 5px;
  width: 19%;
  min-width: 214px;
  &.time-input{
    width: unset;
    padding-left: 0px!important;
    padding-right: 0px!important;
    .container{
      margin-right: 0px;
    }
    ::v-deep .el-select {
        width: 130px !important;
    }
  }
  //溢出隐藏
  overflow: hidden;
  .timeBox {
    line-height: 28px !important;
    height: 28px !important;
    border: none;
  }
  ::v-deep .el-input__inner {
    line-height: 28px !important;
    height: 28px !important;
  }
  ::v-deep .jy-form-input .el-input ,
  ::v-deep .jy-form-time .el-input ,
  ::v-deep .jy-form-select .el-input {
    height: 28px !important;
    line-height: 28px !important;
  }

  ::v-deep .el-input__suffix,
  ::v-deep .jy-form-time .el-input .el-input__suffix,
  ::v-deep .jy-form-select .el-input .el-input__suffix  {
    height: 28px !important;
    line-height: 28px !important;
  }
}
.glo_form{
  padding-left: 15px;
}
</style>
